module.exports = __webpack_public_path__ + "img/quantum-max.60b4c821.png";